import type * as API from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';

type Params = API.Transcripts.DownloadTranscriptTags.Request;

export const useDownloadTranscriptHighlights = (params: Params, options: Omit<UseDownloaderOptions<API.Transcripts.DownloadTranscriptTags.Response>, 'queryKey' | 'queryFn'> = {}) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:transcripts/tags/export`,
      params,
    ],
    queryFn: () => {
      return apiClient.transcripts.downloadTranscriptTags({
        format: params.format,
        transcriptId: params.transcriptId,
      });
    },
    downloaderOptions: {
      onResponse: res => ({
        type: 'websocket',
        value: res.websocketKey,
      }),
    },
    ...options,
  });
};